import React from 'react';
import { NavigationRouteType } from '../context/NavigationContext';
import ToolsRoutes from './ToolsRoutes';

const AdminToolsRoutes = () => (
  <ToolsRoutes routeType={NavigationRouteType.ADMIN} />
);

export default AdminToolsRoutes;
